import { render } from "./NoCustomizationNeeded.vue?vue&type=template&id=049b9b1c&scoped=true"
import script from "./NoCustomizationNeeded.vue?vue&type=script&lang=js"
export * from "./NoCustomizationNeeded.vue?vue&type=script&lang=js"

import "./NoCustomizationNeeded.vue?vue&type=style&index=0&id=049b9b1c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049b9b1c"]])

export default __exports__